<template>
  <div class="row">
    <div class="col-md-12">
      <payment-groups-form :route="route" @on-submit="onUserSubmit"></payment-groups-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import PaymentGroupsForm from './PaymentGroupsForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      PaymentGroupsForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        paymentGroupsModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.paymentGroupsModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/PaymentGroups/PaymentGroupsEdit.vue